import React, { useEffect } from "react";
import { CategoryInterface } from "src/store/community/categoriesSlice";

import { Button, Form, Input } from "antd";
import './_Form.scss';
import FileDropzone from "src/componets/FileDropzone";

interface propsInterface {
  params: CategoryInterface;
  onFinish: Function;
}

const _Form = ({ params, onFinish }: propsInterface) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
  }, [params, form]);

  return (
    <Form
      form={form}
      onFinish={values => onFinish(values)}
      layout="vertical"
      className='v-form'
      initialValues={params}
    >
      <div className='v-group-dropzone'>
        <FileDropzone name='thumbnail' label='Thumbnail' preview={params?.thumbnail_url} />
      </div>

      <Form.Item name='app_id' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <Form.Item name='target' noStyle>
        <Input type="hidden" />
      </Form.Item>

      <Form.Item name='name' label="Name">
        <Input placeholder='Name' />
      </Form.Item>

      <Form.Item>
        <Button className="v-btn v-btn-primary" type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  )
}

export default _Form;
